export const radius = {
  tiny: "4px",
  xxs: "6px",
  xs: "8px",
  sm: "12px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  xxl: "24px",
  xxxl: "32px",
} as const;
